import { useState } from 'react';
import { HtmlContentModalParams } from '../types';
import { htmlHeader } from '@common/constants';

export const useHtmlContentModal = () => {
  const [htmlContentModalParams, setHtmlContentModalParams] = useState<HtmlContentModalParams | undefined>();

  const closeHtmlContentModal = () => {
    setHtmlContentModalParams(undefined);
  };

  const handleContentDescriptionModalOpen = (content: string) => {
    setHtmlContentModalParams({ content, title: 'Content Description' });
  };

  const handleAssociatedContentHtmlModalOpen = (content: string) => {
    setHtmlContentModalParams({ content, title: htmlHeader });
  };

  const handleViewContent = (content: string, title: string) => {
    setHtmlContentModalParams({ content, title });
  };

  return {
    htmlContentModalParams,
    closeHtmlContentModal,
    handleContentDescriptionModalOpen,
    handleAssociatedContentHtmlModalOpen,
    handleViewContent,
  };
};
